<div *ngIf="ShowEditComponent('MENU')">
  <app-microsite-menu [EditOption]="EditOption"></app-microsite-menu>
</div>
<div *ngIf="ShowEditComponent('WELCOME')">
  <app-microsite-highlighter1 [EditOption]="EditOption"></app-microsite-highlighter1>
</div>
<div *ngIf="ShowEditComponent('ABOUTUS')">
  <app-microsite-highlighter1 [EditOption]="EditOption"></app-microsite-highlighter1>
</div>
<div *ngIf="ShowEditComponent('HIGHLIGHTER1')">
  <app-microsite-highlighter1 [EditOption]="EditOption"></app-microsite-highlighter1>
</div>
<div *ngIf="ShowEditComponent('HIGHLIGHTER2')">
  <app-microsite-highlighter1 [EditOption]="EditOption"></app-microsite-highlighter1>
</div>
<div *ngIf="ShowEditComponent('ECOMM')">
  <app-microsite-edit [EditOption]="EditOption"></app-microsite-edit>
</div>
<div *ngIf="ShowEditComponent('GALLERY')">
  <app-microsite-gallery [EditOption]="EditOption"></app-microsite-gallery>
</div>
<div *ngIf="ShowEditComponent('SLIDER')">
  <app-microsite-gallery [EditOption]="EditOption"></app-microsite-gallery>
</div>
<div *ngIf="ShowEditComponent('FACTSHEET')">
  <app-microsite-edit [EditOption]="EditOption"></app-microsite-edit>
</div>
<div *ngIf="ShowEditComponent('BOOK')">
  <app-microsite-book [EditOption]="EditOption"></app-microsite-book>
</div>
<div *ngIf="ShowEditComponent('CONTACTUS')">
  <app-microsite-edit [EditOption]="EditOption"></app-microsite-edit>
</div>
<div *ngIf="ShowEditComponent('MAP')">
  <app-microsite-edit [EditOption]="EditOption"></app-microsite-edit>
</div>
<div *ngIf="ShowEditComponent('CANDID')">
  <app-microsite-candid [EditOption]="EditOption"></app-microsite-candid>
</div>
<div *ngIf="ShowEditComponent('SETTINGS')">
  <app-settings [EditOption]="EditOption"></app-settings>
</div>
<div *ngIf="ShowEditComponent('FOOTER')">
  <app-microsite-highlighter1 [EditOption]="EditOption"></app-microsite-highlighter1>
</div>
<!-- <div *ngIf="ShowEditComponent('ENQUIRY')">
  <app-edit-enquiry-form [EditOption]="EditOption"></app-edit-enquiry-form>
</div> -->